import { authFetch, fetchWithAuth, BASE_BACKEND_URL } from '../auth'
import React, { useEffect, useState } from 'react'
import cookie from 'react-cookies'
import Select from 'react-select'
import { DISCARD_CHANGES_CONFIRMATION } from '../constants/appMessages'
import { canManageEssentials } from '../global_context/capabilities/essentialCapabilities'
import { LocalPagination } from '../layout/LocalPagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faSearch, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { Table } from 'react-bootstrap'
import { iteratee } from 'lodash'
import LoadingScreen from '../components/LoadingScreen'
import { Link } from 'react-router-dom'

export default function EssentialIndexView(props) {
  const [qualifiersData, setQualifiersData] = useState(null)
  const [searchInput, setSearchInput] = useState('')
  const [segmentsData, setSegmentsData] = useState(null)
  const [isFetching, setFetching] = useState(false)
  const [isSaving, setSaving] = useState(false)
  const [isUpdatingQualifier, setUpdatingQualifier] = useState(false)
  const [lastSelectedQualifier, setLastSelectedQualifier] = useState('')
  const [savedQualifier, setSavedQualifier] = useState('')
  const [attributes, setAttributes] = useState([])
  const [segmentList, setSegmentList] = useState({})
  const [currentPageData, setCurrentPageData] = useState([])

  const [showAlert, setShowAlert] = useState(false)

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  const abortCurrentFetchs = () => {
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  const handleChange = (event) => {
    event.preventDefault()
    if (event.target.name === 'qualifierAssociated') {
      setLastSelectedQualifier(event.target.value)
    }
  }

  const handleSearch = (e) => {
    setSearchInput(e.target.value)
  }

  const handleEnterSearch = (e) => {
    if (e.key === 'Enter') {
      // buildSearchQuery()
    }
  }

  const handlePageChange = (newData) => {
    setCurrentPageData(newData)
  }

  const handleSubmitUpdateQualifier = (event) => {
    event.preventDefault()
    setSavedQualifier(lastSelectedQualifier)
    saveQualifiers()
    setUpdatingQualifier(false)
  }

  const handleCancelUpdateQualifier = (event) => {
    event.preventDefault()
    if (window.confirm(DISCARD_CHANGES_CONFIRMATION)) {
      setLastSelectedQualifier(savedQualifier)
      setUpdatingQualifier(false)
    }
  }

  const navigateToAssociateEssential = (e, segment) => {
    window.location = `/asociar_infaltable?attribute=${lastSelectedQualifier}&segment=${segment}`
  }

  useEffect(() => {
    handleSegmentsData()
  }, [segmentsData])

  const buildSegmentArray = (segments, attributeValue) => {
    let arr = []
    let label = attributes.find((e) => e.value === attributeValue)?.label
    if (segments && segments?.length > 0) {
      for (let i = 0; i < segments.length; i++) {
        const segment = segments[i]
        arr.push({ label, segment })
      }
    }
    return arr
  }
  const hasQualifiers = () => {
    const { saved_qualifiers } = qualifiersData?.result || {}
    return (
      saved_qualifiers &&
      (saved_qualifiers.qualifier_2 ||
        saved_qualifiers.qualifier_3 ||
        saved_qualifiers.qualifier_4 ||
        saved_qualifiers.qualifier_5 ||
        saved_qualifiers.qualifier_6 ||
        saved_qualifiers.qualifier_7)
    )
  }

  const handleSegmentsData = () => {
    let toSegmentList = {
      qualifier_2: buildSegmentArray(segmentsData?.qualifier_2, 'qualifier_2'),
      qualifier_3: buildSegmentArray(segmentsData?.qualifier_3, 'qualifier_3'),
      qualifier_4: buildSegmentArray(segmentsData?.qualifier_4, 'qualifier_4'),
      qualifier_5: buildSegmentArray(segmentsData?.qualifier_5, 'qualifier_5'),
      qualifier_6: buildSegmentArray(segmentsData?.qualifier_6, 'qualifier_6'),
      qualifier_7: buildSegmentArray(segmentsData?.qualifier_7, 'qualifier_7')
    }
    setSegmentList(toSegmentList)
  }

  useEffect(() => {
    handleQualifierData()
  }, [qualifiersData])

  const handleCloseAlert = () => {
    setShowAlert(false)
  }

  const handleQualifierData = async () => {
    let availableQualifiers = qualifiersData?.result?.available_qualifiers
    let savedQualifiers = qualifiersData?.result?.saved_qualifiers
    let toAttributes = []

    if (savedQualifiers && savedQualifiers?.essential_qualifier_value) {
      setLastSelectedQualifier(savedQualifiers.essential_qualifier_value)
      setSavedQualifier(savedQualifiers.essential_qualifier_value)
    }
    if (savedQualifiers && savedQualifiers?.qualifier_2) {
      // qualifier 2 - Atributo A
      let qualifier2 = availableQualifiers.find(
        (item) => item.value === savedQualifiers?.qualifier_2
      )
      toAttributes.push({
        value: 'qualifier_2',
        name: `Atributo A - ${qualifier2?.label}`,
        label: qualifier2?.label,
        key: qualifier2?.value
      })

      // qualifier 3 - Atributo B
      if (savedQualifiers?.qualifier_3) {
        let qualifier3 = availableQualifiers.find(
          (item) => item.value === savedQualifiers?.qualifier_3
        )
        toAttributes.push({
          value: 'qualifier_3',
          name: `Atributo B - ${qualifier3?.label}`,
          label: qualifier3?.label,
          key: qualifier3?.value
        })
      }

      // qualifier 4 - Atributo C
      if (savedQualifiers?.qualifier_4) {
        let qualifier4 = availableQualifiers.find(
          (item) => item.value === savedQualifiers?.qualifier_4
        )
        toAttributes.push({
          value: 'qualifier_4',
          name: `Atributo C - ${qualifier4?.label}`,
          label: qualifier4?.label,
          key: qualifier4?.value
        })
      }

      // qualifier 5 - Atributo D
      if (savedQualifiers?.qualifier_5) {
        let qualifier5 = availableQualifiers.find(
          (item) => item.value === savedQualifiers?.qualifier_5
        )
        toAttributes.push({
          value: 'qualifier_5',
          name: `Atributo D - ${qualifier5?.label}`,
          label: qualifier5?.label,
          key: qualifier5?.value
        })
      }

      // qualifier 6 - Atributo E
      if (savedQualifiers?.qualifier_6) {
        let qualifier6 = availableQualifiers.find(
          (item) => item.value === savedQualifiers?.qualifier_6
        )
        toAttributes.push({
          value: 'qualifier_6',
          name: `Atributo E - ${qualifier6?.label}`,
          label: qualifier6?.label,
          key: qualifier6?.value
        })
      }

      // qualifier 7 - Atributo F
      if (savedQualifiers?.qualifier_7) {
        let qualifier7 = availableQualifiers.find(
          (item) => item.value === savedQualifiers?.qualifier_7
        )
        toAttributes.push({
          value: 'qualifier_7',
          name: `Atributo F - ${qualifier7?.label}`,
          label: qualifier7?.label,
          key: qualifier7?.value
        })
      }
      setAttributes(toAttributes)
    }
  }

  const fetchQualifiersFromServer = async () => {
    setFetching(true)
    try {
      const response = await authFetch(
        `${BASE_BACKEND_URL}/qualifiers`,
        {
          method: 'GET',
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
      if (response.status === 401) {
        return console.error(response)
      }
      const data = await response.json()
      setQualifiersData(data)
      setFetching(false)
    } catch (error) {
      if (error !== 'Fetch Aborted by User.') {
        console.error('Error:', error)
      }
    }
  }

  const fetchPromoQualifiers = async () => {
    setFetching(true)
    const response = await fetchWithAuth(`${BASE_BACKEND_URL}/promo_qualifiers`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
    if (!response || response.error) {
      return console.error(
        `Error in fetchFilterInfoFromServer: ${response ? response.status : 'Fetch error'}`
      )
    }
    const data = response
    setSegmentsData(data.result[0])
    setFetching(false)
  }

  const saveQualifiers = async () => {
    setSaving(true)

    const response = await authFetch(
      `${BASE_BACKEND_URL}/qualifiers`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          essential_qualifier_value: lastSelectedQualifier
        })
      }
    )
    if (response.status === 401) {
      return console.error(response)
    }
    const data = await response.json()
    // await fetchQualifiersFromServer(false)
    setSaving(false)
    setSavedQualifier(lastSelectedQualifier)

    fetchQualifiersFromServer()
  }

  const getDisplayableData = () => {
    if (!segmentList || !savedQualifier) return []
    const allData = segmentList[savedQualifier] || []
    if (searchInput !== '') {
      return allData.filter((item) =>
        item.segment?.toLowerCase().includes(searchInput.toLowerCase())
      )
    }
    return allData
  }

  useEffect(() => {
    const toDisplay = getDisplayableData()
    setCurrentPageData(toDisplay)
  }, [savedQualifier, segmentList, searchInput])

  useEffect(() => {
    async function fetcher() {
      await fetchQualifiersFromServer()
      await fetchPromoQualifiers()
    }
    fetcher()
  }, [])

  useEffect(() => {
    if (savedQualifier) {
      fetchPromoQualifiers()
    }
  }, [savedQualifier])

  if (isFetching === false) {
    return (
      <>
        {showAlert && (
          <div
            className="alert alert-info d-flex justify-content-between align-items-center"
            role="alert"
          >
            <strong className="success-message">
              Debe establecer al menos un segmento para poder configurar los infaltables.{' '}
              <Link to="/segmentos">Ir a Segmentos</Link>
            </strong>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowAlert(false)}
              aria-label="Close"
            ></button>
          </div>
        )}
        <div>
          <div className="index-header detailed-container">
            <h2>Productos Infaltables</h2>

            {isUpdatingQualifier === false &&
              canManageEssentials() && (
                <div className="index-buttons">
                  <button
                    onClick={() => {
                      if (!hasQualifiers()) {
                        setShowAlert(true)
                      } else {
                        setUpdatingQualifier(true)
                        setShowAlert(false)
                      }
                    }}
                  >
                    Actualizar Atributo
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className="index-table">
          <div className="show-area">
            <div className="header-infaltables-container">
              <div className="full-width">
                <p>
                  <b className="note-essentials">Nota: </b> Los productos infaltables son productos
                  que deben tener mayor importancia o prioridad en la gestión de ventas. Estos
                  productos se pueden configurar siguiendo su segmentación de clientes. Debe
                  seleccionar un solo atributo y configurar los productos infaltables para cada
                  segmento de ese atributo.
                </p>
              </div>

              <div className="full-width header-infaltables-button-group-left">
                {isUpdatingQualifier === true && (
                  <div>
                    <button className="cancel-button" onClick={handleCancelUpdateQualifier}>
                      Cancelar
                    </button>
                    <input
                      className="save-button"
                      value="Guardar"
                      type="button"
                      onClick={handleSubmitUpdateQualifier}
                    />
                  </div>
                )}
              </div>
            </div>
            <hr className="mb-10" />
            <div className="mb-30 mt-30 infaltables-attribute-selector-container">
              <p className="mr-10 ft-18">Atributo asociado a infaltables:</p>
              {isFetching && <h4> Cargando...</h4>}
              {!isUpdatingQualifier && savedQualifier == '' && !isFetching && (
                <p className="ft-18"> SIN ASIGNAR</p>
              )}
              {!isUpdatingQualifier && savedQualifier !== '' && !isFetching && (
                <h5 className="mt--8">
                  {attributes.find((e) => e.value == lastSelectedQualifier)?.name}
                </h5>
              )}
              {isUpdatingQualifier === true && (
                <div className="">
                  <select
                    className="essential-qualifier-select"
                    onChange={handleChange}
                    name="qualifierAssociated"
                  >
                    <option value="" hidden>
                      Seleccione un atributo
                    </option>
                    {attributes.map((segment, i) => {
                      return (
                        <option key={i} value={segment.value}>
                          {segment.name}
                        </option>
                      )
                    })}
                  </select>
                </div>
              )}
            </div>
            <div className="mt-20">
              <p className="mr-10 ft-18">Asocie el listado de productos:</p>
              <div className="title-and-search-containter mb-20">
                <p className="ft-14">
                  {' '}
                  Usted puede asociar una lista de productos individual a cada segmento.
                </p>
                <div className="search-input-containter">
                  <input
                    value={searchInput}
                    onChange={handleSearch}
                    onKeyDown={handleEnterSearch}
                    className="round-search-input ft-12"
                    placeholder="Buscar por segmento"
                  />

                  {searchInput === '' && (
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="search-icon"
                      style={{ marginTop: -1 }}
                    />
                  )}
                  {searchInput && (
                    <div
                      title="Limpiar texto"
                      onClick={() => {
                        setSearchInput('')
                      }}
                      className="round-search-input-x"
                    >
                      X
                    </div>
                  )}
                </div>
              </div>

              <Table hover responsive style={{ width: '100%', tableLayout: 'fixed' }}>
                <thead className="table-header-gray">
                  <tr>
                    <th style={{ verticalAlign: 'middle', padding: '10px 25px' }}>
                      <span className="th-header-text">#</span>
                    </th>
                    <th style={{ verticalAlign: 'middle' }}>
                      <span className="th-header-text">ATRIBUTO</span>
                    </th>
                    <th style={{ verticalAlign: 'middle', width: '10%' }}>
                      <span className="th-header-text">SEGMENTO</span>
                    </th>
                    <th
                      style={{ textAlign: 'right', paddingRight: '75px', verticalAlign: 'middle' }}
                    >
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {savedQualifier == '' && (
                    <tr>
                      <td colSpan="4" className="td-text-limited td-text-limited-space">
                        No tiene configuraciones activas en estos momentos
                      </td>
                    </tr>
                  )}
                  {savedQualifier !== '' && (!currentPageData || currentPageData?.length == 0) && (
                    <tr>
                      <td colSpan="4" className="td-text-limited td-text-limited-space">
                        No hay resultados
                      </td>
                    </tr>
                  )}
                  {savedQualifier !== '' &&
                    currentPageData?.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td className="td-text-limited td-text-limited-space">{i + 1}</td>
                          <td className="td-text-limited">{item.label}</td>
                          <td className="td-text-limited">{item.segment}</td>
                          <td className="td-text-limited" style={{ textAlign: 'right' }}>
                            {!isUpdatingQualifier && !isSaving && (
                              <button
                                onClick={(e) => navigateToAssociateEssential(e, item.segment)}
                                className="ubiqua-secondary-btn"
                                type="button"
                              >
                                Ver{' '}
                                {canManageEssentials()
                                  ? 'o asociar'
                                  : ''}{' '}
                                productos
                              </button>
                            )}
                            {(isUpdatingQualifier || isSaving) && (
                              <button
                                title="Debe guardar los cambios para poder asociar productos"
                                disabled
                                className="ubiqua-secondary-btn disabled"
                                type="button"
                              >
                                Ver{' '}
                                {canManageEssentials()
                                  ? 'o asociar'
                                  : ''}{' '}
                                productos
                              </button>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </Table>
            </div>
            <LocalPagination
              data={getDisplayableData()}
              onPageChange={handlePageChange}
              searchInput={searchInput}
              display={getDisplayableData()?.length > 50}
            />
          </div>
        </div>
      </>
    )
  } else {
    return (
      <LoadingScreen text="Cargando..." />
    )
  }
}
